import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Please enter your email.");
      return;
    }
    setLoading(true);
    try {
      await api.createLead({ type: "newsletter", email, consent: true });
      toast.success("You're subscribed", { description: "Quarterly Monaco-Geneva intelligence, nothing more." });
      setEmail("");
    } catch (err) {
      toast.error("Subscription failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex items-center gap-2" data-testid="newsletter-form">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your work email"
        data-testid="newsletter-email-input"
        className="h-11 w-full rounded-[var(--radius-sm)] border border-[color:var(--bp-border)] bg-[color:var(--bp-bg)] px-4 text-sm text-[color:var(--bp-cream)] placeholder:text-[color:var(--bp-text-muted)]/60 focus:border-[color:var(--bp-teal)] focus:outline-none"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit-button"
        aria-label="Subscribe"
        className="inline-flex h-11 shrink-0 items-center justify-center rounded-[var(--radius-sm)] bg-[color:var(--bp-teal)] px-4 text-[color:var(--bp-bg)] transition-shadow hover:shadow-[var(--shadow-lift)] disabled:opacity-60"
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4" />}
      </button>
    </form>
  );
};
